import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataService, TextDocumentVersion } from '../../../shared/dataService';

@Component({
  selector: 'app-document-version',
  templateUrl: './document-version.component.html',
  styleUrls: ['./document-version.component.scss']
})
export class DocumentVersionComponent implements OnInit {
  documentVersion: TextDocumentVersion | null = null;
  isLoading = true;
  isError = false;
  documentId: string | null = null;
  versionId: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService
  ) {}

  ngOnInit(): void {
    this.documentId = this.route.snapshot.paramMap.get('id');
    this.versionId = this.route.snapshot.paramMap.get('versionId');
    
    if (this.documentId && this.versionId) {
      this.fetchDocumentVersion(this.documentId, this.versionId);
    } else {
      this.isError = true;
      this.isLoading = false;
    }
  }

  private fetchDocumentVersion(documentId: string, versionId: string): void {
    this.isLoading = true;
    this.isError = false;
    
    this.dataService.getDocumentVersionById(documentId, versionId).subscribe({
      next: (documentVersion) => {
        this.documentVersion = documentVersion;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error fetching document version:', error);
        this.isError = true;
        this.isLoading = false;
      }
    });
  }

  get documentHtml(): string {
    if (!this.documentVersion || !this.documentVersion.text) {
      return '';
    }
    return this.documentVersion.text;
  }
}

